import React, { useState } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	IconButton
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';

interface InfoDialogButtonProps {
	title: string;
	text: string;
	linkLabel?: string;
	linkUrl?: string;
}

const InfoDialogButton: React.FC<InfoDialogButtonProps> = ({ title, text, linkLabel, linkUrl }) => {
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const { t } = useTranslation();

	return (
		<>
			<IconButton
				onClick={handleOpen}
				sx={{
					padding: 0,
					background: 'transparent',
					'&:hover': {
						background: 'transparent'
					}
				}}
			>
				<InfoIcon color="warning" />
			</IconButton>

			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>
					<Typography variant="h6">{title}</Typography>
				</DialogTitle>
				<DialogContent
					sx={{
						paddingTop: 1,
						paddingBottom: 0,
						border: 'none'
					}}
				>
					<Typography variant="body2">{text}</Typography>
				</DialogContent>
				<DialogActions>
					{linkLabel && linkUrl && (
						<Button
							href={linkUrl}
							target="_blank"
							rel="noopener"
							color="primary"
							sx={{ color: 'rgba(75, 88, 108, 1)' }}
						>
							{linkLabel}
						</Button>
					)}
					<Button onClick={handleClose} autoFocus>
						{t('general:cta_close')}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export { InfoDialogButton };
